/* @flow */
import React from 'react'
import { i18n } from '@/locale/i18n'
import { SuccessIcon } from '@/assets/icons'

class MarketFollow extends React.PureComponent {
  render() {
    const { is_followed } = this.props
    return (
      <div className="flex items-center gap-4">
        <SuccessIcon />
        <div className="message__text">
          <div className="message__main-text">
            {is_followed ? i18n('bet.unfollow_market') : i18n('bet.follow_market')}
          </div>
        </div>
      </div>
    )
  }
}

export default MarketFollow
